import { render, staticRenderFns } from "./internationalAbatementReminder.vue?vue&type=template&id=208014a6"
import script from "./internationalAbatementReminder.vue?vue&type=script&lang=js"
export * from "./internationalAbatementReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports